import { MultiSelect } from "@mantine/core"
import { useTheme } from "../../ThemeContext";

export const InlineMultiSelect = (props) => {

    const { theme } = useTheme();
    const { error } = props;
    return (
        <MultiSelect
            {...props}
            sx={{
                '.mantine-MultiSelect-input:focus-within': {
                    // border: theme === 'dark' ? '2px solid #37395B' : '2px solid #E9ECEF'
                    border: '0px',
                    boxShadow: `inset 0 0 0 2px ${error ? '#A15959' : theme === 'dark' ? '#37395B' : '#E9ECEF'}`
                },
                '.mantine-MultiSelect-error': {
                    color: '#A15959',
                    fontSize: '1.2rem',
                },
                '.mantine-MultiSelect-rightSection svg': {
                    color: error ? '#A15959 !important' : theme === 'dark' ? '#9aa1a7' : '#B4B4B8',
                },
                input: {
                    padding: '0.4rem 0px',
                    '&::placeholder': {
                        color: '#bebeca',
                        letterSpacing: '0.07rem',
                        fontSize: '1.6rem'
                    }
                },
            }}
            styles={{
                input: {
                    boxSizing: 'border-box',
                    borderRadius: '6px',
                    backgroundColor: theme === 'dark' ? 'transparent' : '#ffffff',
                    // border: theme === 'dark' ? '1px solid #37395B' : '1px solid #E9ECEF'
                    border: '0px',
                    boxShadow: `inset 0 0 0 1px ${error ? '#A15959' : theme === 'dark' ? '#37395B' : '#E9ECEF'}`
                },
                label: {
                    fontWeight: '600',
                    fontSize: '1.5rem',
                    color: error ? '#A15959' : theme === 'dark' ? '#9aa1a7' : '#B4B4B8'
                }
            }}
        />
    )
}